import script from "./CzechiaGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./CzechiaGuide.vue?vue&type=script&lang=ts&setup=true"

import "./CzechiaGuide.vue?vue&type=style&index=0&id=fe864564&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe864564"]])

export default __exports__